export const normalizeDisplayValue = (value?: string | null, fallback = '—') => {
  if (value == null) {
    return fallback;
  }

  const trimmed = value.trim();
  if (!trimmed || trimmed === '--') {
    return fallback;
  }

  return trimmed;
};

export const extractErrorMessage = (error: unknown, fallback: string) => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message?: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message;
  }

  return fallback;
};
